// extracted by mini-css-extract-plugin
module.exports = {"container":"_3aLkA","header":"SeoMT","notPGLayout":"_39DE5","notPgLayout":"_39DE5","withPadding":"_19SDW","menu":"_24EAQ"};